import Vue from 'vue'

import Cookies from 'js-cookie'
import qs from 'qs'

import 'normalize.css/normalize.css' // a modern alternative to CSS resets

// import Element from 'element-ui'
import ElementUI from 'element-ui'
import moment from 'moment'
import './styles/element-variables.scss'
import permission from '@/directive/permission/index.js' // 权限判断指令
// import enLang from 'element-ui/lib/locale/lang/zh-CN'// 如果使用中文语言包请默认支持，无需额外引入，请删除该依赖
// import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
import preventReClick from './utils/preventReClick' // 防多次点击，重复提交

import '@/styles/index.scss' // global css

import App from './App'
import store from './store'
import router from './router'

import './icons' // icon
import './permission' // permission control
import './utils/error-log' // error log

import * as filters from './filters' // global filters

import { jiemai } from "./utils/jiemai"
import VCharts from 'v-charts'
Vue.use(VCharts)
// 引入echarts
import echarts from 'echarts'
Vue.prototype.$echarts = echarts
/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online ! ! !
 */
if (process.env.NODE_ENV === 'production') {
  const { mockXHR } = require('../mock')
  mockXHR()
}

// Vue.use(Element, {
//   size: Cookies.get('size') || 'medium' // set element-ui default size
//   // locale: enLang // 如果使用中文，无需设置，请删除
// })
Vue.use(ElementUI)
Vue.use(permission)
Vue.prototype.moment = moment
Vue.prototype.$qs = qs
// 捷迈紧急需求 需要吧三个项目做特殊处理
Vue.prototype.$jiemai = jiemai

// register global utility filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.config.productionTip = false

// 可以拖拽的dialog
import dragDialog from '@/components/drag-dialog'
Vue.use(dragDialog)

import bbInputType from "@/components/InputType";
Vue.component("bb-inputType", bbInputType);

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
